document.addEventListener('DOMContentLoaded', () => {
	const menus = document.querySelectorAll('[data-tab-menu]');

	menus.forEach((menu) => {
		menu.addEventListener('click', () => {
			sessionStorage.setItem(
				'position',
				String(document.documentElement.scrollTop),
			);
		});

		const scrollPosition = sessionStorage.getItem('position');
		if (scrollPosition) {
			window.scrollTo(0, Number(scrollPosition));
			sessionStorage.removeItem('position');
		}
	});
});
